"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var utils_1 = require("../../utils");
var Box_1 = require("../Box");
var hocs_1 = require("../hocs");
var RadioGroup_1 = require("../RadioGroup");
var withFormFields_hoc_1 = require("../withFormFields/withFormFields.hoc");
var StyledRadioButton_1 = require("./StyledRadioButton");
var RadioButtonInnner = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonInnner, _super);
    function RadioButtonInnner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButtonInnner.prototype.render = function () {
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, forwardRef = _a.forwardRef, id = _a.id, label = _a.label, name = _a.name, onChange = _a.onChange, theme = _a.theme, value = _a.value, className = _a.className, fill = _a.fill, size = _a.size, color = _a.color, rest = tslib_1.__rest(_a, ["checked", "disabled", "forwardRef", "id", "label", "name", "onChange", "theme", "value", "className", "fill", "size", "color"]);
        var normalizedLabel = typeof label === 'string' ? React.createElement("span", null, label) : label;
        var Icon = theme && theme.radioButton.icons.circle;
        var borderColor = theme
            ? checked
                ? utils_1.normalizeColor(theme.radioButton.color || 'control', theme)
                : utils_1.normalizeColor(theme.radioButton.border.color, theme)
            : undefined;
        return (React.createElement(RadioGroup_1.RadioContext.Consumer, null, function (radioContext) {
            return (React.createElement(StyledRadioButton_1.StyledRadioButtonContainer, tslib_1.__assign({ as: Box_1.Box, tag: "label", direction: "row", align: "center" }, utils_1.removeUndefined({ htmlFor: id, disabled: disabled }), { theme: theme, onClick: function (event) {
                    // prevents clicking on the label trigging the event twice
                    // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
                    if (event.target.type !== 'radio') {
                        event.stopPropagation();
                    }
                }, className: className, htmlFor: radioContext && radioContext.id ? radioContext.id + "-" + id : id, size: size, color: color }),
                React.createElement(StyledRadioButton_1.StyledRadioButton, { as: Box_1.Box, margin: { right: (theme && theme.radioButton.gap) || 'xsmall' }, theme: theme },
                    React.createElement(StyledRadioButton_1.StyledRadioButtonInput, tslib_1.__assign({}, rest, { ref: forwardRef, type: "radio", id: radioContext && radioContext.id ? radioContext.id + "-" + id : id }, utils_1.removeUndefined({
                        value: value,
                        name: name || radioContext.name,
                        checked: checked || radioContext.value === value,
                        disabled: disabled,
                        // if RadioGroup is provided, use its onChange handler
                        onChange: radioContext.onChange || onChange
                    }), { theme: theme })),
                    React.createElement(StyledRadioButton_1.StyledRadioButtonBox, { tabIndex: "0", theme: theme, as: Box_1.Box, align: "center", justify: "center", width: theme && theme.radioButton.size, height: theme && theme.radioButton.size, border: {
                            size: theme && theme.radioButton.border.width,
                            color: borderColor
                        }, round: theme && theme.radioButton.check.radius }, (checked || radioContext.value === value) &&
                        (Icon ? (React.createElement(Icon, { as: StyledRadioButton_1.StyledRadioButtonIcon, theme: theme })) : (React.createElement(StyledRadioButton_1.StyledRadioButtonIcon, { viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet", theme: theme, fill: fill },
                            React.createElement("circle", { cx: 12, cy: 12, r: 6 })))))),
                normalizedLabel));
        }));
    };
    return RadioButtonInnner;
}(React.Component));
/** @component */
exports.RadioButton = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(RadioButtonInnner);
exports.FormRadioButton = withFormFields_hoc_1.withFormFields(RadioButtonInnner);
//# sourceMappingURL=RadioButton.js.map